export enum ConsultantUnfitType {
  Unfit = "Unfit",
  NotContactable = "NotContactable"
}
